import BatteryDegradationJumpLink from './BatteryDegradationJumpLink';

export default BatteryDegradationJumpLink;
